import type { ImportPiece } from './api'

const fixHero = (x: ImportPiece): ImportPiece => ({ ...x, hero: x.hero != null && x.images.includes(x.hero) ? x.hero : x.images[0] ?? null })

export function mergeWithNext(ps: ImportPiece[], key: string): ImportPiece[] {
  const i = ps.findIndex((x) => x.key === key)
  const a = ps[i], b = ps[i + 1]
  if (!a || !b || a.file !== b.file) return ps
  const merged = fixHero({ ...a, end: b.end, images: [...a.images, ...b.images], dropped: a.dropped && b.dropped })
  return [...ps.slice(0, i), merged, ...ps.slice(i + 2)]
}

export function splitAt(ps: ImportPiece[], key: string, headingIndex: number, title: string): ImportPiece[] {
  const i = ps.findIndex((x) => x.key === key)
  const a = ps[i]
  if (!a || headingIndex <= a.start || headingIndex >= a.end) return ps
  const left = fixHero({ ...a, end: headingIndex, images: a.images.filter((n) => n < headingIndex) })
  const right = fixHero({ ...a, key: `${a.file}:${headingIndex}`, start: headingIndex, title, byline: null,
    images: a.images.filter((n) => n >= headingIndex), hero: null, already_published: null, draft_id: null, error: null })
  return [...ps.slice(0, i), left, right, ...ps.slice(i + 1)]
}

export function moveImage(ps: ImportPiece[], fromKey: string, imageIndex: number, toKey: string): ImportPiece[] {
  const file = ps.find((y) => y.key === fromKey)?.file
  return ps.map((x) => x.key === fromKey ? fixHero({ ...x, images: x.images.filter((n) => n !== imageIndex) })
    : x.key === toKey && x.file === file ? fixHero({ ...x, images: [...x.images, imageIndex] }) : x)
}

export const setDropped = (ps: ImportPiece[], key: string, dropped: boolean) => ps.map((x) => x.key === key ? { ...x, dropped } : x)
export const rename = (ps: ImportPiece[], key: string, title: string) => ps.map((x) => x.key === key ? { ...x, title } : x)
export const setHero = (ps: ImportPiece[], key: string, imageIndex: number) =>
  ps.map((x) => x.key === key && x.images.includes(imageIndex) ? { ...x, hero: imageIndex } : x)

export function toBody(ps: ImportPiece[]): object[] {
  return ps.map(({ key, file, start, end, title, byline, images, hero, dropped }) => ({ key, file, start, end, title, byline, images, hero, dropped }))
}

/** The PUT body after one structural edit; the server recomputes every derived field. */
export const bodyAfter = (ps: ImportPiece[], edit: (ps: ImportPiece[]) => ImportPiece[]): object[] => toBody(edit(ps))
export const hasBlankTitle = (ps: ImportPiece[]): boolean => ps.some((x) => !x.title.trim())
